import axios from "./axios.service";

export const getExam = (id) => {
  return axios.get(`/quiz/${id}/without/answer`).then((res) => res.quiz);
};
